import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { X, ArrowRight, Sparkles, Plane, Search, MessageSquare, ShieldCheck } from "lucide-react";

const STEPS = [
  { Ic: Sparkles, title: "Bienvenue sur TravelBuddy 👋", body: "En 30 secondes, découvrez comment publier ou trouver un trajet.", cta: "Commencer" },
  { Ic: Plane, title: "Publier un trajet", body: "Ouvrez le wizard en 6 étapes : mode, lieux, dates, exclusions… Votre trajet est visible instantanément.", cta: "Suivant", link: "/wizard" },
  { Ic: Search, title: "Chercher un buddy", body: "Départ + arrivée + dates → résultats en 3 clics. Débloquez un contact pour 2€ (ou via abonnement / parrainage).", cta: "Suivant", link: "/search" },
  { Ic: MessageSquare, title: "Chat sécurisé", body: "Une fois débloqué, discutez dans le chat interne. Numéros et emails sont masqués automatiquement.", cta: "Suivant" },
  { Ic: ShieldCheck, title: "Séquestre de mission", body: "Sécurisez le paiement : Stripe gèle les fonds jusqu'à la confirmation de réception.", cta: "C'est parti !" },
];

export default function OnboardingTour() {
  const { user } = useAuth();
  const [idx, setIdx] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    const seen = localStorage.getItem("tb_onboarded");
    if (!seen) setOpen(true);
  }, [user]);

  if (!user || !open) return null;
  const step = STEPS[idx];
  const finish = () => { localStorage.setItem("tb_onboarded", "1"); setOpen(false); };

  return (
    <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="glass-strong rounded-2xl w-full max-w-md p-6 relative">
        <button data-testid="tour-close" onClick={finish} className="absolute top-3 right-3 text-slate-400 hover:text-white"><X size={18}/></button>
        <div className="flex items-center gap-2 text-[#F59E0B] text-xs uppercase tracking-wider mb-3">Étape {idx+1} / {STEPS.length}</div>
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#FF6B6B] to-[#F59E0B] flex items-center justify-center mb-4">
          <step.Ic size={22} className="text-white"/>
        </div>
        <h2 className="font-display text-2xl font-bold mb-2">{step.title}</h2>
        <p className="text-sm text-slate-300">{step.body}</p>
        <div className="mt-6 flex items-center gap-2">
          {idx < STEPS.length - 1 ? (
            <>
              <button data-testid="tour-skip" onClick={finish} className="btn-ghost-glass px-3 py-2 rounded-lg text-xs">Passer</button>
              <button data-testid="tour-next" onClick={()=>setIdx(idx+1)} className="btn-coral px-4 py-2 rounded-lg text-sm flex-1 flex items-center justify-center gap-1">
                {step.cta} <ArrowRight size={14}/>
              </button>
            </>
          ) : (
            <>
              <button data-testid="tour-close-final" onClick={finish} className="btn-ghost-glass px-3 py-2 rounded-lg text-xs">Fermer</button>
              <Link data-testid="tour-cta-publish" to="/wizard" onClick={finish} className="btn-coral px-4 py-2 rounded-lg text-sm flex-1 flex items-center justify-center gap-1">
                Publier mon 1er trajet <ArrowRight size={14}/>
              </Link>
            </>
          )}
        </div>
        <div className="mt-4 flex justify-center gap-1">
          {STEPS.map((_, i) => (
            <div key={i} className={`h-1 w-6 rounded-full transition ${i<=idx ? "bg-[#FF6B6B]" : "bg-slate-700"}`}/>
          ))}
        </div>
      </div>
    </div>
  );
}
